import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 菜单
    menus: JSON.parse(localStorage.getItem('menus')) || [],
    // 区域
    regions: JSON.parse(localStorage.getItem('regions')) || [],
    // 地物
    features: JSON.parse(localStorage.getItem('features')) || []
  },
  getters: {
  },
  mutations: {
    setMenus (state, payload) {
      state.menus = payload
    },

    setRegions (state, payload) {
      state.regions = payload
    },

    setFeatures (state, payload) {
      state.features = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
